export const CHANGE_UI_STATE = 'CHANGE_UI_STATE'
export const TOKEN_UPDATE = 'TOKEN_UPDATE'
export const TOKEN_REMOVE = 'TOKEN_REMOVE'
export const USER_UPDATE = 'USER_UPDATE'
export const USER_REMOVE = 'USER_REMOVE'
